import { render, staticRenderFns } from "./ShipmentDetailsComponent.vue?vue&type=template&id=52987bf9&scoped=true"
import script from "./ShipmentDetailsComponent.vue?vue&type=script&lang=js"
export * from "./ShipmentDetailsComponent.vue?vue&type=script&lang=js"
import style0 from "./ShipmentDetailsComponent.vue?vue&type=style&index=0&id=52987bf9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52987bf9",
  null
  
)

export default component.exports